import { Link } from 'react-router-dom';
import LoginHeaderImage from '../../assets/images/login_Name_logo.jpg'

import Footer from '../../components/footer';

import './landingPage.css';

export default function LandingPage() {

    const Navigation = () => {
        return (
            <div className="col __height">
                <div className="row">
                    <div className="col-1 col-sm-2 col-md-3 col-lg-4 col-xl-4 col-xxl-4"></div>
                    <div className="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-4 col-xxl-4 landingPage rounded text-center p-5 pt-2 pb-3">
                        <div className="row mt-1">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-center">
                                <img src={LoginHeaderImage} alt="Your Image" className="img-fluid HeaderName" />
                            </div>
                        </div>
                        {/*<p className="m-0 p-0 fw-bold">Warahena</p>*/}
                        <div className="row mt-1">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                <Link to="/room">
                                    <button type="button" className="form-control btn btn-primary">Room</button>
                                </Link>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                <Link to="/guest">
                                    <button type="button" className="form-control btn btn-primary">Guest</button>
                                </Link>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                <Link to="/steward">
                                    <button type="button" className="form-control btn btn-primary">Steward</button>
                                </Link>
                            </div>
                        </div>
                        <Footer />
                    </div>
                    <div className="col-1 col-sm-2 col-md-3 col-lg-4 col-xl-4 col-xxl-4"></div>
                </div>
            </div>
        );
    }

    return (
        <Navigation />
    );
}